export const buildUrl = (
  pathname: string,
  query: Record<
    string,
    string | number | boolean | null | undefined | (string | number | boolean)[]
  >
) => {
  const params = new URLSearchParams();

  for (const [key, value] of Object.entries(query)) {
    if (value === undefined || value === null) continue;

    if (Array.isArray(value)) {
      for (const item of value) {
        if (item !== null && item !== undefined) {
          params.append(key, String(item));
        }
      }
    } else {
      params.append(key, String(value));
    }
  }

  return `${pathname}?${params.toString()}`;
};

export const normalizePath = (path: string) => {
  if (!path || typeof path !== 'string') {
    return '/';
  }
  const cleaned = path.replace(/^\/+/, "").replace(/\/+$/, "").replace(/\/+/g, "/");
  return cleaned ? "/" + cleaned : '/';
};

export const joinNestedPath = (parent?: string, child?: string): string => {
  const cleanParent = (parent ?? "").replace(/\/+$/, "");
  const cleanChild = (child ?? "").replace(/^\/+/, "");
  return `/${cleanParent}/${cleanChild}`.replace(/\/+/g, "/");
};
